/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Carrier_Returned_DescInputs */

const vi_order_carrier_returned_desc = /** @type {(inputs: Order_Carrier_Returned_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi lại thông tin lô hàng đã hoàn về (số kiện, tình trạng, …). Bắt buộc nhập tối thiểu 3 ký tự.`)
};

/**

* @param {Order_Carrier_Returned_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_carrier_returned_desc = /** @type {((inputs?: Order_Carrier_Returned_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Carrier_Returned_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_carrier_returned_desc(inputs)
});